<template>
    <div>
        <el-form>
          类型名称:<el-input v-model="type_name" class="max-w460"></el-input>
        </el-form>
        
        <el-form>
            是否启用:
          <el-radio-group v-model="status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form>

          <div class="mt16">
            <el-form size="small">
                <el-form-item>

                    <el-col :span="3" style="margin-left: 30px;">
                     属性名称
                    </el-col>
                    <el-col :span="3">
                        属性值
                    </el-col>
                    <el-col :span="3">
                        所属类型
                    </el-col>
                    <el-col :span="3" style="margin-left: 70px;">
                        操作
                    </el-col>
                </el-form-item>
             
                <el-form-item v-for="(item,index) in wholesaleList"  :key="index" >
                    
                    <el-col :span="3" style="margin: 10px;float: left;">
                          <el-input v-model="item.attr_name" autocomplete="off" placeholder="请输入属性名称" ></el-input>
                    </el-col>
                    
                    <el-col :span="3" style="margin: 10px;float: left;">
                         <span>{{item.attr_value}}</span>
                    </el-col>
                    
                    <el-col :span="3" style="margin: 10px;float: left;margin-left: -10px;">
                      <el-select v-model="item.attr_type" @change="optStatus(index)">
                        <el-option  label="输入框" value="1"></el-option>
                        <el-option  label="单选框" value="2"></el-option>
                        <el-option  label="复选框" value="3"></el-option>
                      </el-select>
                    </el-col>

                    <el-col :span="3" style="float: left;margin-left: 30px;margin-right: 50px;padding-top: 10px;">
                        <div style="display: flex;">
                            <el-button v-if="item.display == 1" @click.prevent="openAttr(index,item.attr_value)">编辑属性值</el-button>
                            <el-button @click.prevent="removeWholesale(index)">删除</el-button>
                        </div>
                       
                    </el-col>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addWholesale">＋添加一个属性</el-button>
            </div>

            <div class="common-button-wrapper">
              <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
             <el-button size="small" type="primary" @click="editWholesale" :loading="loading">发布</el-button>
            </div>

            <!--修改-->
            <Attr v-if="is_attr" :is_attr="is_attr" :attr_index="attr_index"  :wholesaleList="wholesaleList" :attr_value="attr_value" @closeDialog="closeDialogFunc"></Attr>
        </div>
    </div>
</template>

<script>
    import ProductApi from '@/api/product.js';
    import Attr from './attr.vue';
    export default {
        components: {
          Attr,
        },
        data() {
            return {
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                loading: false,
                attr_id:'',
                dialogVisible: false,
                type_name:'',
                status:1,
                is_attr:0,
                attr_index:0,
                attr_value:'',
                wholesaleList:[{
                    attr_name:'',
                    attr_type:'1',
                    display:0,
                    attr_value:''
                }],
            };
        },
        // props: ['is_open_wholesale','form'],
       
        created() {
            this.attr_id = this.$route.query.attr_id;
            this.getData();
            // if(this.form.wholesale_price){
            //     this.wholesaleList = this.form.wholesale_price;
            // }

            // if(this.wholesaleList.length==0){

            //     this.wholesaleList.push({
            //         min_num: '',
            //         max_num: '',
            //         wholesale_price:''
            //     });
            // }           
            // this.dialogVisible = this.$parent.is_open_wholesale;
        },
        methods: {
            getData(){
                let self = this
                ProductApi.getAttrEditData({attr_id:this.attr_id}, true)
                .then(data => {
                    self.loading = false;
                    self.type_name = data.data.data.attr_name
                    self.status = data.data.data.status
                    self.wholesaleList = data.data.data.list
                })
                .catch(error => {
                    self.loading = false;
                });
            },
            addWholesale(){
                this.wholesaleList.push({
                    attr_name:'',
                    attr_type:'1',
                    display:0,
                    attr_value:''
                });
            },
            editWholesale(){
                let self =this;
                let params = {};
                let validateFlag = false;
                if(!self.type_name){
                    self.$message({
                        message: '类型名称不可为空',
                        type: 'error'
                    });
                    return false;
                }

                this.wholesaleList.forEach(function (item) {
                    if(!item.attr_name){
                        self.$message({
                            message: '属性名称不可都为空',
                            type: 'error'
                        });
                        validateFlag = true;
                        return false;
                    }
                    if(!item.attr_type){
                         self.$message({
                            message: '属性类型不可为空',
                            type: 'error'
                        });
                        validateFlag = true;
                        return false;
                    }
                    
                })
                if(validateFlag){
                    return false;
                }

                params.type_name = self.type_name
                params.status = self.status
                params.attr = JSON.stringify(this.wholesaleList);
                params.source = 'edit';
                params.attr_id = self.attr_id
                // console.log(params)
                // params.is_open_wholesale = params.is_open_wholesale=='false'?0:1;
                ProductApi.addAttrTemplate(params, true)
                .then(data => {
                    self.loading = false;
                    self.$message({
                      message: '添加成功',
                      type: 'success'
                    });
                    self.$router.push('/product/attribute/index');
                    // self.dialogFormVisible(1);
                })
                .catch(error => {
                    self.loading = false;
                });
                    
            },
            removeWholesale(index){
                // var index = this.wholesaleList.domains.indexOf(item)
                if (index !== -1) {
                    this.wholesaleList.splice(index, 1)
                }
            },
            /*取消*/
            cancelFunc() {
              this.$router.back(-1);
            },
            // 下拉变化
            optStatus(index){
                if(this.wholesaleList[index].attr_type == 1){
                    this.wholesaleList[index].display = 0;
                }else{
                    this.wholesaleList[index].display = 1;
                }
                
            },
            // 添加属性值
            openAttr(index,value){
                this.attr_index = index
                this.is_attr = 1
                this.attr_value = value
            },
            closeDialogFunc(){
                this.is_attr = 0
            }
        }
    }
</script>

<style scoped>
    /deep/ .el-form-item__content{
        width: 940px;
    }
    .max-w460{
        max-width: 200px;
        margin: 10px;
    }
    .mt16{
        margin-top: 50px;
    }
</style>



// WEBPACK FOOTER //
// src/views/product/attribute/edit.vue